export default __webpack_public_path__ + "static/media/strategy_manual.f031c3d5.docx";